import $ from 'jquery'
import prop from 'vue-strict-prop'
import { componentFactoryOf } from 'vue-tsx-support'

interface Events {
	onConfirm(el: HTMLElement): void
	onDecline(el: HTMLElement): void
	onHidden(): void
	onShow(): void
	onVisible(): void
}

export default componentFactoryOf<Events>().create({
	name: 'Modal',
	props: {
		closable: prop(Boolean).default(true),
		open: prop(Boolean).default(false),
		transition: prop.ofStringLiterals('scale').default('scale'),
	},
	data() {
		return {
			approve: false,
		}
	},
	watch: {
		open(newValue: string): void {
			if (newValue) {
				this.show()
			}
			else {
				this.hide()
			}
		},
	},
	mounted() {
		$(this.$el)
			.modal('setting', 'closable', this.closable)
			.modal('setting', 'transition', this.transition)
			.modal({
				onApprove: () => {
					this.approve = true
					return true
				},
				onDeny: () => {
					this.approve = false
					return true
				},
				onHidden: () => {
					this.$emit('hidden')
					this.$emit(this.approve ? 'confirm' : 'decline')
				},
				onShow: () => {
					this.$emit('show')
				},
				onVisible: () => {
					this.$emit('visible')
				},
			})

		if (this.open) {
			this.show()
		}
	},
	methods: {
		hide(): void {
			$(this.$el).modal('hide')
		},
		show(): void {
			$(this.$el).modal('show')
		},
	},
	render() {
		return (
			<div class="ui modal">
				{this.$slots.default}
			</div>
		)
	},
})
